module.exports = __webpack_public_path__ + "img/place1.96a209df.svg";